import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFonts , getPairData} from "../utils/getFonts";
import { GET_FONT, GET_FONT_PAIRS } from "../store/types/font";
import { generateRandomNumber } from "../utils";
const loadFont = (name, url) => {
  const newStyle = document.getElementById("font_faces");
  const navLink = document.getElementById("nav_links");
  newStyle.appendChild(
    document.createTextNode(
      "@font-face{ font-display: block; font-family: '" + name + "'; src: url(" + url + ");}"
    )
  );
  const newrelLink = document.createElement("link");
  newrelLink.type = 'font/ttf';
  newrelLink.rel = 'preload';
  newrelLink.as = 'font'
  newrelLink.href = url
  newrelLink.crossOrigin="anonymous" 
  // navLink.appendChild(newrelLink);
 
};


export const useFonts = () => {

  const dispatch = useDispatch();
  
  const { fontPairs } = useSelector((state) => state.font);
  
  const fontApiCall = useCallback(async () => {
    if (document.getElementById('font_faces')?.childNodes?.length > 100){
      return;
    }
    const fontPair = await getFonts();
    for (let index = 0; index < fontPair.length; index++) {
      let randomIndex = generateRandomNumber(fontPair);
      if(randomIndex === index) {
        randomIndex = typeof fontPair[randomIndex] === 'undefined' || fontPair.length === randomIndex ? randomIndex - 1 : randomIndex + 1 ;
      } 
      loadFont(fontPair[index]._source.font, fontPair[index]._source.url);

    }
    dispatch({ type: GET_FONT, payload: fontPair });
  }, [dispatch]);

  useEffect(() => {
    // if (fontPairs.length > 0) return;
    fontApiCall();
  }, [fontApiCall, fontPairs]);

  return;
};